export default {"src":"/_next/static/media/training.adcd127b.svg","height":106,"width":106,"blurWidth":0,"blurHeight":0};